import React from "react";
import { components } from "react-select";
import styled from "styled-components";

import { Icon } from "src/shared/components";

const StyledIcon = styled(Icon)`
  > path {
    stroke: ${({ theme }) => theme.globalConstants.color.white};
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MultiValueRemoveComponent = (props: any) => (
  <components.MultiValueRemove {...props}>
    <StyledIcon name="x" size="12px" />
  </components.MultiValueRemove>
);

export default MultiValueRemoveComponent;
